import { NFTType } from "interfaces";
import { utils } from "services";
import StaticAnim from "services/staticanim";

export const RewardLayout = ({
    onSelect,
    isActive,
    isDisabled,
    data,
}: {
    onSelect?: Function;
    isActive?: boolean;
    isDisabled?: boolean;
    data: any,
}) => {

    return (
        <div>
            <div className={`relative exchange-box-shadow rounded-lg border-2 cursor-pointer ${isActive && "active-reward"}  ${isDisabled && "inactive-reward"}`}
                onClick={(evt: any) => {
                    if (onSelect && !isDisabled) {
                        onSelect(evt.target.value);
                    }
                }}
            >
                <div className="w-[109px] h-[109px] bg-[#141416] bg-epic justify-center rounded-2xl">
                    <div className="w-full h-full top-0 left-0 flex items-center justify-center">
                        {
                            data.type === NFTType.Plot &&
                            <img
                                src={utils.getPlotIcon(data)}
                                className={`object-cover h-[56px] -translate-y-2`}
                                alt="reward"
                            />
                        }
                        {
                            data.type === NFTType.SoulCore &&
                            <img
                                src={utils.getSoulcoreIcon(data)}
                                className={`object-cover h-[56px] -translate-y-2`}
                                alt="reward"
                            />
                        }
                        {
                            data.type === NFTType.Mongen &&
                            <div className="">
                                <StaticAnim
                                    lock={[]}
                                    dna={data.dna}
                                />
                            </div>
                        }
                        {isActive && <img
                            src="/assets/images/icons/check.png" alt="check"
                            className={`object-cover -translate-y-2 absolute w-[42px] h-[42px]`}
                        />}
                        {data.point && (
                            <div className="text-white text-sm cursor-pointer absolute right-2 top-0 font-medium">
                                + {data.point} Points
                            </div>
                        )}
                        {/* {data.rarity != null && (
                            <div className="text-red cursor-pointer absolute translate-x-11 -translate-y-8">
                                <img
                                    src={utils.getRarityIcon(data.rarity)}
                                    alt="rarity"
                                    className="w-6 h-6"
                                />
                            </div>
                        )} */}
                        <div className="text-white text-center absolute bottom-2">#{data.id}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
